import React from 'react';
import { CSkeleton } from 'src/common';
import { ExportCSV } from 'src/components/ActionsSection/comps';
import { EventKind, useEventsQuery } from 'src/graphql/_generated';
import { isQueryLoading } from 'src/graphql/client';
import { useAuth } from 'src/state/auth';

interface ExportActionsCSVProps {
  exportIds: string[];
}

export const ExportActionsCSV: React.FC<ExportActionsCSVProps> = ({ exportIds }) => {
  const { workspaceId } = useAuth();

  const { data, loading, networkStatus } = useEventsQuery({
    variables: {
      workspaceId: workspaceId,
      eventType: EventKind.Action,
    },
  });
  const isLoading = isQueryLoading({ loading, data, networkStatus });

  const events = data?.events?.filter((el) => exportIds.includes(el.id)) || [];

  return (
    <>
      {isLoading ? (
        <CSkeleton width={52} height={52} />
      ) : (
        <>{!!events.length && <ExportCSV events={events || []} name="Actions" />}</>
      )}
    </>
  );
};
